import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsOfAcceptanceComponent } from './terms-of-acceptance.component';



@NgModule({
  declarations: [TermsOfAcceptanceComponent],
  exports: [
    TermsOfAcceptanceComponent,
  ],
  imports: [
    CommonModule,
  ],
})
export class TermsOfAcceptanceModule { }
